import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, useLocation } from 'react-router-dom'
import App from './App'
import AdminDashboard from './admin/AdminDashboard'
import PwaParityApp from './pwa/PwaParityApp'
import './styles.css'
import './pwa/parity-theme-overrides.css'
import './marketing-logo.css'
import './marketing-screenshot.css'

if ('serviceWorker' in navigator && location.pathname.startsWith('/pwa')) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/pwa/sw.js', { scope: '/pwa/' }).catch(console.warn))
}

function RoutedRoot() {
  const location = useLocation()
  if (location.pathname.startsWith('/admin')) return <AdminDashboard />
  return location.pathname.startsWith('/pwa') ? <PwaParityApp /> : <App />
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <RoutedRoot />
    </BrowserRouter>
  </StrictMode>,
)
